import { addQuarters, isSameDay, startOfDay, startOfQuarter } from 'date-fns'
import { z } from 'zod'

/** True when `date` is the first day of a quarter that ended before `today`. */
export const isEndedQuarterStart = (date: Date, today: Date = new Date()) =>
  isSameDay(date, startOfQuarter(date)) &&
  addQuarters(startOfDay(date), 1) <= startOfDay(today)

export const payHealthStipendSchema = z.object({
  quarterStartDate: z
    .date({ required_error: 'Select the first day of a quarter.' })
    .refine((date) => isEndedQuarterStart(date), {
      message: 'Select the first day of a quarter that has ended.',
    }),
  workerId: z
    .string()
    .trim()
    .regex(/^[1-9]\d*$/, { message: 'Enter one valid worker ID.' }),
  overrideVelocityControls: z.boolean(),
})

export type PayHealthStipendSchema = z.infer<typeof payHealthStipendSchema>
